import { render } from "./productSlide.vue?vue&type=template&id=c83523a4&scoped=true"
import script from "./productSlide.vue?vue&type=script&lang=js"
export * from "./productSlide.vue?vue&type=script&lang=js"

import "./productSlide.vue?vue&type=style&index=0&id=c83523a4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c83523a4"]])

export default __exports__